// Permanent listener – rivyo re-render hone par bhi chalega
setInterval(() => {

    const widget = document.querySelector('.wc_review_widget');
    const actions = document.querySelector('.wc_rivyo_actions');
    const summaryAction = document.querySelector('.wc_review_summary_action ul');

    if (!widget || !actions || !summaryAction) return;

    // Default hide once per re-render
    if (!widget.dataset.hiddenApplied) {
        widget.style.display = "none";
        actions.style.display = "none";
        widget.dataset.hiddenApplied = "true";
    }

    // Remove head click (Rivyo re-add karta hai)
    const head = document.querySelector('.wc_review_head');
    if (head && !head.dataset.cleaned) {
        head.replaceWith(head.cloneNode(true));
        head.dataset.cleaned = "true";
    }

    // Add button if missing (Rivyo re-render hote hi button delete ho jata)
    if (!document.querySelector('.see-all-reviews-btn')) {

        const newLi = document.createElement('li');
        const newBtn = document.createElement('button');

        newBtn.type = "button";
        newBtn.className = "see-all-reviews-btn";

        newBtn.style.cssText = `
            cursor: pointer;
            display: flex;
            gap: 8px;
            align-items: center;
            color: #fff;
            background-color: #000;
            border: 3px solid #000;
            padding: 14px 20px;
            line-height: 20px;
            justify-content: center;
        `;

        newBtn.innerHTML = `See All Reviews <span class="toggle-icon">+</span>`;

        newLi.appendChild(newBtn);
        summaryAction.appendChild(newLi);

        // Toggle logic
        newBtn.addEventListener("click", function () {

            const isHidden = widget.style.display === "none";
            const icon = newBtn.querySelector(".toggle-icon");

            widget.style.display = isHidden ? "block" : "none";
            actions.style.display = isHidden ? "flex" : "none";

            icon.textContent = isHidden ? "−" : "+";
        });
    }

}, 400);


/* =========================================================================
   Ring collection custom filter — AJAX (no full-page reload) patch
   --------------------------------------------------------------------------
   Problem fixed: on the ring-collection filter, selecting a shape, dragging a
   slider, or removing a filter tag triggered form.submit() / location.href,
   which reloaded the whole page and scrolled to top on every interaction.
   This patch updates the product grid in place via AJAX instead. It only acts
   on the custom filter form (#FacetFiltersFormCleanOrigin) and falls back to
   the old full-page behaviour if anything is missing or a request fails.
   ========================================================================= */
(function () {
  'use strict';

  var FORM_ID = 'FacetFiltersFormCleanOrigin';
  var TAGS_ID = 'unifiedFilterTags';

  function getForm() {
    return document.getElementById(FORM_ID);
  }

  // Fetch the collection section for the given query string and swap the grid in place.
  function renderFromParams(searchParams, updateHistory) {
    var gridEl = document.getElementById('product-grid');
    var container = document.getElementById('ProductGridContainer');
    var sectionId = gridEl ? gridEl.getAttribute('data-id') : null;
    var targetUrl = window.location.pathname + (searchParams ? '?' + searchParams : '');

    // If expected markup is missing, fall back to the old full-page behaviour.
    if (!container || !sectionId) {
      window.location.href = targetUrl;
      return;
    }

    var collectionEl = container.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    var spinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    spinners.forEach(function (s) { s.classList.remove('hidden'); });

    var fetchUrl =
      window.location.pathname + '?section_id=' + sectionId + (searchParams ? '&' + searchParams : '');

    fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');

        var newContainer = doc.getElementById('ProductGridContainer');
        if (newContainer) container.innerHTML = newContainer.innerHTML;

        ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
          var src = doc.getElementById(id);
          var dest = document.getElementById(id);
          if (src && dest) {
            dest.innerHTML = src.innerHTML;
            dest.classList.remove('loading');
          }
        });

        spinners.forEach(function (s) { s.classList.add('hidden'); });

        if (updateHistory !== false) {
          history.pushState({ rfSearchParams: searchParams }, '', targetUrl);
        }

        // Re-bind wishlist / compare buttons on freshly injected cards (matches theme behaviour).
        if (typeof initButtons === 'function') initButtons();
        if (typeof initButtonsCompare === 'function') initButtonsCompare();
      })
      .catch(function () {
        window.location.href = targetUrl;
      });
  }

  // 1) Intercept the theme's programmatic form.submit() calls (shape clicks, sliders).
  //    Programmatic submit() does NOT fire the 'submit' event, so we patch the method itself.
  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (this && this.id === FORM_ID) {
      renderFromParams(new URLSearchParams(new FormData(this)).toString(), true);
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  // 2) Intercept a genuine submit event (e.g. Enter key inside a price input).
  document.addEventListener(
    'submit',
    function (e) {
      if (e.target && e.target.id === FORM_ID) {
        e.preventDefault();
        renderFromParams(new URLSearchParams(new FormData(e.target)).toString(), true);
      }
    },
    true
  );

  // Build a query string from the current URL with one filter param removed.
  function paramsWithout(paramName, paramValue) {
    var url = new URL(window.location.href);
    var sp = url.searchParams;
    if (paramValue) {
      var kept = sp.getAll(paramName).filter(function (v) { return v !== paramValue; });
      sp.delete(paramName);
      kept.forEach(function (v) { sp.append(paramName, v); });
    } else {
      sp.delete(paramName);
      if (paramName.indexOf('price') !== -1) {
        var base = paramName.replace('.gte', '').replace('.lte', '');
        sp.delete(base + '.gte');
        sp.delete(base + '.lte');
      }
    }
    return sp.toString();
  }

  function removeChip(filterId) {
    var box = document.getElementById(TAGS_ID);
    if (!box) return;
    box.querySelectorAll('.clean-origin-filter-tag[data-filter="' + filterId + '"]').forEach(function (chip) {
      chip.remove();
    });
    if (!box.querySelector('.clean-origin-filter-tag')) box.classList.add('empty');
  }

  // Reset the price slider DOM (inputs + handles) so a removed price filter is not re-submitted.
  function resetPriceFilter(filterId) {
    var track = document.querySelector('.custom-price-track[data-filter="' + filterId + '"]');
    if (!track) return;
    var c = track.closest('.custom-price-filter-container') || track.parentElement;
    if (!c) return;
    var min = parseInt(track.getAttribute('data-min'), 10) || 0;
    var max = parseInt(track.getAttribute('data-max'), 10) || 0;
    var mi = c.querySelector('.custom-price-input-min');
    var ma = c.querySelector('.custom-price-input-max');
    if (mi) mi.value = (min / 100).toFixed(2);
    if (ma) ma.value = (max / 100).toFixed(2);
    var minH = c.querySelector('.custom-price-handle-min');
    var maxH = c.querySelector('.custom-price-handle-max');
    var prog = c.querySelector('.custom-price-progress');
    if (minH) minH.style.left = '0%';
    if (maxH) maxH.style.left = '100%';
    if (prog) { prog.style.left = '0%'; prog.style.width = '100%'; }
  }

  // Reset a discrete range slider (color/clarity/carat) DOM so removed values are not re-submitted.
  function resetRangeFilter(filterId) {
    var track = document.querySelector('.clean-origin-track[data-filter="' + filterId + '"]');
    if (!track) return;
    var c = track.closest('.clean-origin-slider-container') || track.parentElement;
    if (!c) return;
    c.querySelectorAll('.clean-origin-value-label').forEach(function (lbl) {
      var id = lbl.getAttribute('data-input');
      var inp = id ? document.getElementById(id) : null;
      if (inp) inp.checked = false;
      lbl.classList.remove('faded', 'selected-start', 'selected-end');
    });
    var lh = c.querySelector('.left-handle');
    var rh = c.querySelector('.right-handle');
    var prog = c.querySelector('.clean-origin-progress');
    if (lh) lh.style.left = '0%';
    if (rh) rh.style.left = '100%';
    if (prog) { prog.style.left = '0%'; prog.style.width = '100%'; }
  }

  // 3) Replace the theme's tag-removal handlers so they update via AJAX instead of redirecting.
  //    custom.js runs after the filter's inline script, so these globals already exist.
  function patchRemovers() {
    window.removeShapeTag = function (filterId, value, paramName) {
      var input = document.querySelector('input[type="checkbox"][value="' + value + '"]');
      if (input) {
        input.checked = false;
        var wrapper = input.closest('.shape-option-wrapper');
        if (wrapper) {
          var opt = wrapper.querySelector('.shape-option');
          if (opt) opt.classList.remove('active');
        }
      }
      removeChip(filterId);
      renderFromParams(paramsWithout(paramName, value), true);
    };

    window.removePriceTag = function (filterId) {
      resetPriceFilter(filterId);
      removeChip(filterId);
      renderFromParams(paramsWithout(filterId), true);
    };

    window.cleanOriginRemoveFilter = function (filterId) {
      resetRangeFilter(filterId);
      removeChip(filterId);
      renderFromParams(paramsWithout(filterId), true);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchRemovers);
  } else {
    patchRemovers();
  }

  // 4) Back / forward should re-render the grid in place (no reload).
  window.addEventListener('popstate', function (event) {
    var params =
      event.state && typeof event.state.rfSearchParams !== 'undefined'
        ? event.state.rfSearchParams
        : window.location.search.slice(1);
    renderFromParams(params, false);
  });
})();


/* =========================================================================
   Ring filter UI tweaks
   - Rename the "Diamond Color" filter label to "Color" on EVERY collection
     (custom ring filter + standard Dawn facets), and keep it renamed after
     the standard facets re-render via AJAX (MutationObserver).
   - Render the "Creation Method" filter as toggle buttons on the ring filter
     (active = black bg / white text; Lab Grown highlighted by default).
   ========================================================================= */
(function () {
  'use strict';

  var CM_FILTER = 'filter.v.option.creation method';
  var COLOR_FILTER = 'filter.p.m.custom.ring_color';

  function injectStyles() {
    if (document.getElementById('rf-ui-tweaks-style')) return;
    var css =
      '.rf-toggle-filter .clean-origin-track,' +
      '.rf-toggle-filter .clean-origin-progress,' +
      '.rf-toggle-filter .clean-origin-handle{display:none !important;}' +
      '.rf-toggle-filter .clean-origin-values{display:flex;flex-wrap:wrap;gap:10px;margin:0;padding:0 20px !important;}' +
      '.rf-toggle-filter .clean-origin-value-label{flex:0 0 auto;border:1px solid #000;background:#fff;color:#000;' +
      'padding:10px 22px;margin:0;cursor:pointer;text-align:center;font-size:12px;letter-spacing:.5px;' +
      'text-transform:uppercase;line-height:1;border-radius:0;opacity:1 !important;transition:background .2s ease,color .2s ease;}' +
      '.rf-toggle-filter .clean-origin-value-label.faded,' +
      '.rf-toggle-filter .clean-origin-value-label.selected-start,' +
      '.rf-toggle-filter .clean-origin-value-label.selected-end{opacity:1 !important;}' +
      '.rf-toggle-filter .clean-origin-value-label.rf-active{background:#000 !important;color:#fff !important;}';
    var style = document.createElement('style');
    style.id = 'rf-ui-tweaks-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // Replace the visible "Diamond Color" text with "Color" inside filter UI only
  // (never touches the product grid / descriptions).
  function renameColorInScopes() {
    var scopes = document.querySelectorAll(
      'facet-filters-form, .facets-container, .active-facets, .mobile-facets, #unifiedFilterTags'
    );
    scopes.forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var node, targets = [];
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf('Diamond Color') !== -1) targets.push(node);
      }
      targets.forEach(function (tn) {
        tn.nodeValue = tn.nodeValue.replace(/Diamond Color/g, 'Color');
      });
    });
    // Keep the ring color slider's chip label correct at the source.
    var t = document.querySelector('.clean-origin-track[data-filter="' + COLOR_FILTER + '"]');
    if (t && t.getAttribute('data-filter-label') !== 'Color') t.setAttribute('data-filter-label', 'Color');
  }

  var renamePending = false;
  function scheduleRename() {
    if (renamePending) return;
    renamePending = true;
    setTimeout(function () { renamePending = false; renameColorInScopes(); }, 60);
  }

  function enhanceCreationMethod() {
    var track = document.querySelector('.clean-origin-track[data-filter="' + CM_FILTER + '"]');
    var container = track ? track.closest('.clean-origin-slider-container') : null;
    if (!container || container.dataset.rfToggled) return;
    container.dataset.rfToggled = '1';
    container.classList.add('rf-toggle-filter');

    var labels = Array.prototype.slice.call(container.querySelectorAll('.clean-origin-value-label'));
    if (!labels.length) return;

    function setActive(active) {
      labels.forEach(function (l) { l.classList.toggle('rf-active', l === active); });
    }

    // Reflect current URL selection, else default to the first option (Lab Grown).
    var selected = new URLSearchParams(window.location.search).getAll(CM_FILTER);
    var initial = null;
    if (selected.length) {
      labels.forEach(function (l) {
        if (selected.indexOf(l.getAttribute('data-value')) !== -1) initial = l;
      });
    }
    setActive(initial || labels[0]);

    labels.forEach(function (l) {
      l.addEventListener('click', function () { setActive(l); }, true);
    });
  }

  function run() {
    injectStyles();
    renameColorInScopes();
    enhanceCreationMethod();

    // Re-apply the rename whenever the facets are re-rendered (standard Dawn AJAX filtering).
    if (!window.__rfColorObserver) {
      window.__rfColorObserver = new MutationObserver(scheduleRename);
      window.__rfColorObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
